import axios from "axios";
import { CoreAPIRoutes } from "../application/apiSources";
import { getAuthHeader } from "../application/connection";

const RoleFetchService =  {
  get: () => axios.get(CoreAPIRoutes.ROLE, { headers: getAuthHeader() }),
  getAll: () => axios.get(`${CoreAPIRoutes.ROLE}all`, { headers: getAuthHeader() }),
}

export default RoleFetchService;
